import { useEffect, useRef, useState } from "react";
import { homeFilms } from "@/data/home-films";

export function HomeFilmSequence({ playing = false }: { playing?: boolean } = {}) {
  const [active, setActive] = useState(0);
  const [, setReducedMotion] = useState(false);
  const refs = useRef<Array<HTMLVideoElement | null>>([]);

  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  useEffect(() => {
    refs.current.forEach((video, index) => {
      if (!video) return;
      if (index === active && playing) {
        video.play().catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }, [active, playing]);

  return (
    <div className="absolute inset-0" aria-hidden="true">
      {homeFilms.map((film, index) => (
        <video
          key={film.id}
          ref={(element) => { refs.current[index] = element; }}
          poster={film.poster}
          muted
          playsInline
                    loop={homeFilms.length === 1}
          preload={index === active ? "auto" : "metadata"}
          onEnded={() => setActive((current) => (current + 1) % homeFilms.length)}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 motion-reduce:transition-none ${index === active ? "opacity-100" : "opacity-0"}`}
        >
          {"webm" in film && film.webm ? <source src={film.webm} type="video/webm" /> : null}
          <source src={film.src} type="video/mp4" />
        </video>
      ))}
    </div>
  );
}